import React from 'react';

import { Container } from './styles';

const ButtonPrimaryGreen = ({ children, icon: Icon, ...rest }) => {
  return (
    <Container>
      <button type="button" {...rest}>
        {Icon && <Icon size={16} color="#fff" />}
        {children}
      </button>
    </Container>
  );
};

export default ButtonPrimaryGreen;
